<template>
    <report-card-dialog :model-value="true" :reportCardId="reportCardId" :cancel="false" persistent/>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ReportCardDialog from '../dialogs/ReportCardDialog.vue';
import { usePageTitle } from '../../composables/usePageTitle';

defineProps<{ reportCardId: string }>();

const { t } = useI18n();

usePageTitle(computed(() => [{ text: t('PAGE_TITLE_REPORT_CARD') }]));
</script>
